// Add select2 to select element
(function($, Drupal) {
  "use strict";
  Drupal.behaviors.default = {
    attach: function(context, settings) {
      $(".form-select").select2({});
    }
  };
})(jQuery, Drupal);
